import { z } from "zod";

import { hpAssigneeResolutionSchema } from "@/configuration/groups/heartplace/hp-assignee-resolution";
import { createCustomerDataAccessors } from "@/src/lib/workflows/steps/preflight-customer-data";

const hpPreflightCustomerDataSchema = z.object({
  shouldMarkReviewed: z.boolean(),
  assigneeResolution: hpAssigneeResolutionSchema,
  providerHierarchyNote: z.string().nullable().optional(),
});

export type HpPreflightCustomerData = z.infer<typeof hpPreflightCustomerDataSchema>;

export const { build: buildHpCustomerData, read: readHpCustomerData } =
  createCustomerDataAccessors<HpPreflightCustomerData>(
    "hp",
    (x): x is HpPreflightCustomerData => hpPreflightCustomerDataSchema.safeParse(x).success
  );
